import { PlusOutlined, SafetyCertificateTwoTone } from '@ant-design/icons';
import { Button, Card, Divider, Typography } from 'antd';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import TransformationCard from '../transformations/TransformationCard';
import ChainStepSortable from './ChainStepSortable';

const { Title } = Typography;

const MappingChain = ({ mappingData, onChange }) => {
  // mappingData shape: { steps: [...], default_transformation: {...} }

  // --- STEPS MANAGEMENT ---

  const handleAddStep = () => {
    const newStep = {
      uuid: uuidv4(),
      condition: { uuid: uuidv4(), field: '', operator: 'equals', value: '' },
      transformation: { type: null, params: {} },
    };
    onChange({
      ...mappingData,
      steps: [...(mappingData.steps || []), newStep],
    });
  };

  const handleRemoveStep = (index) => {
    const newSteps = mappingData.steps.filter((_, i) => i !== index);
    onChange({ ...mappingData, steps: newSteps });
  };

  const handleStepChange = (index, updatedStep) => {
    const newSteps = [...mappingData.steps];
    newSteps[index] = updatedStep;
    onChange({ ...mappingData, steps: newSteps });
  };

  // --- DEFAULT TRANSFORMATION MANAGEMENT ---

  const handleDefaultTransformationChange = (newTrans) => {
    onChange({
      ...mappingData,
      default_transformation: newTrans,
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* CHAIN STEPS */}
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 16,
          }}
        >
          <Title level={5} style={{ margin: 0 }}>
            Étapes de transformation
          </Title>
        </div>

        {/* DEFAULT TRANSFORMATION (ELSE) */}
        <div>
          <Card
            size="small"
            style={{ backgroundColor: '#d075ff12', borderColor: '#d075ff' }}
          >
            <Title level={5} style={{ margin: 0 }}>
              <SafetyCertificateTwoTone twoToneColor="#d075ff" /> Transformation
              par défaut
            </Title>
            <TransformationCard
              transformationData={mappingData.default_transformation}
              onTransformationChange={handleDefaultTransformationChange}
              isControlled={true}
              isDefault={true}
              fieldNamePrefix={['chain', 'default_transformation']}
            />
          </Card>
        </div>

        <Divider />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {mappingData.steps?.map((step, index) => (
            <ChainStepSortable
              key={step.uuid || index}
              id={step.uuid}
              step={step}
              index={index}
              onStepChange={handleStepChange}
              onRemoveStep={handleRemoveStep}
            />
          ))}
        </div>

        <Button
          type="primary"
          onClick={handleAddStep}
          block
          icon={<PlusOutlined />}
          style={{ marginTop: 16 }}
        >
          Ajouter une étape
        </Button>
      </div>
    </div>
  );
};

export default MappingChain;
